import { watch, toRaw, onUnmounted } from 'vue'
import { writeDom, cancelFastDom } from 'gleam-shared/browser/fastDom'

export default function useHelpCenterHistoryManager(frame, currentRouteRef) {
  watch(currentRouteRef, onCurrentRouteChange)

  onUnmounted(() => {
    cancelFastDom(updateScroll)
  })

  function onCurrentRouteChange(currentRoute, oldRoute) {
    if (!currentRoute.popstate) {
      const state = currentRoute.type === frame.type ? frame : null
      const method = oldRoute ? 'pushState' : 'replaceState'
      changeState(method, state, currentRoute.href)
    }

    writeDom(updateScroll, currentRouteRef.value)
  }

  function changeState(method, state, url) {
    try {
      window.history[method](toRaw(state), null, url)
    } catch (err) {
      console.warn('Could not update the history state due to', err)
    }
  }

  function updateScroll(currentRoute) {
    const anchorId = currentRoute.hash.replace(/^#/, '') // querySelector won't find an ID starting with a digit
    const anchor = anchorId ? document.getElementById(anchorId) : null

    if (anchor) {
      scrollToAnchor(anchor)
    } else {
      scrollToTop()
    }
  }

  function scrollToAnchor(anchor) {
    anchor.scrollIntoView()
  }

  function scrollToTop() {
    window.scrollTo({ top: 0 })
  }
}
